const VARIANT_MAP = {
  active: 'success',
  verified: 'success',
  complete: 'success',
  paid: 'success',
  ready: 'success',
  inactive: 'neutral',
  pending: 'warning',
  unverified: 'warning',
  missing: 'warning',
  draft: 'neutral',
  overdue: 'danger',
  disputed: 'danger',
  void: 'danger',
  sent: 'info',
  partial: 'info',
  ready_partial: 'info',
  not_ready: 'warning',
};

export default function Badge({ children, variant }) {
  const resolved = variant || VARIANT_MAP[String(children).toLowerCase()] || 'neutral';
  return <span className={`badge badge-${resolved}`}>{children}</span>;
}
